import React from 'react'
import { message } from 'antd'
import { uploadToQiniu } from '../../api/uploadImg'
import { IMAGE_DOMAIN } from '../../config'
import { postTableDetail } from '../../api/clubProfession'
import { postSingleReservationSettingData } from '../../api/bookings'
import { isValuable, validateImageFile } from '../../util'

const OK = 1
// 检查俱乐部信息填写情况
export const checkTableInfoValues = (tableInfoData) => {
  if (tableInfoData) {
    const { name, groupId, clz, hourPrice, lampNumber, order } = tableInfoData
    if (!name) {
      message.error('请填写桌台名称')
      return false
    }
    if (!groupId) {
      message.error('请选择分组')
      return false
    }
    if (!isValuable(clz)) {
      message.error('请选择类型')
      return false
    }
    if (clz == 1 && (!isValuable(hourPrice) || +hourPrice < 0)) {
      message.error('基本价格需大于或等于0')
      return false
    }
    if (clz != 1 && (!isValuable(hourPrice) || +hourPrice <= 0)) {
      message.error('基本价格需大于0')
      return false
    }
    if (!isValuable(lampNumber)) {
      message.error('请填写灯箱编号')
      return false
    }
    if (!isValuable(order)) {
      message.error('桌台编号')
      return false
    }
    return true
  }
  message.error('请填写完数据再提交！')
  return false
}
// 设置俱乐部信息数据给服务器
export const postTableInfo = async (tableInfoData, callback) => {
  const {
    id,
    name,
    fileList,
    groupId,
    clz,
    hourPrice,
    minConsumption,
    lampNumber,
    order,
    postpaid,
    instantlyCheckout,
    settings,
  } = tableInfoData
  let photo = ''
  if (fileList.length > 0) {
    const fileItem = fileList[0]
    photo = fileItem.url
    if (!fileItem.uploaded) {
      if (!validateImageFile(fileItem.file)) {
        callback && callback(false)
        return
      }
      const res = await uploadToQiniu(fileItem.file)
      console.log('图片结果', res)
      if (res && res.status == 200) {
        photo = IMAGE_DOMAIN + res.data.url
      }
    }
  }
  const postData = {
    minConsumption: minConsumption * 60,
    table: {
      id,
      name,
      postpaid,
      lampNumber,
      hourPrice: hourPrice * 100,
      clz,
      instantlyCheckout,
      order,
    },
    group: {
      id: groupId,
      isNew: false,
    },
    photos: !photo ? [] : [photo],
    settings,
  }
  console.log('上传数据', postData)
  const { status, detail } = await postTableDetail(postData)
  if (status != 1) {
    message.error(detail)
    callback && callback(false)
    return
  }
  message.success('设置成功')
  callback && callback(true)
}

// 设置预订数据给服务器
export const postBooksInfo = async (postBookingsData, callback) => {
  const { tableIds, reservationProperty, beforeList, afterList } =
    postBookingsData
  const beFilter = beforeList.filter((bt) => bt.duration && bt.ratio)
  const afFilter = afterList.filter((bt) => bt.duration && bt.ratio)
  const cancelFee = [...beFilter, ...afFilter].map((item) => {
    return {
      ...item,
      duration: item.duration * 60,
      ratio: item.ratio / 100,
    }
  })
  if (reservationProperty.createTime) {
    delete reservationProperty.createTime
  }
  if (reservationProperty.updateTime) {
    delete reservationProperty.updateTime
  }
  const params = {
    reservationProperty: {
      ...reservationProperty,
      // minReservationDuration: reservationProperty.minReservationDuration * 60,
    },
    cancelFee,
    tableIds,
  }
  const { status, detail, data } = await postSingleReservationSettingData(
    params
  )
  if (status != OK) {
    message.error(detail)
    callback && callback(false)
    return
  }
  message.success('设置成功')
  callback && callback(true)
}

// 检查预订数据填写情况
export const checkBookingsValues = (bookData) => {
  if (bookData) {
    const { beforeList, afterList, reservationProperty, rangDates } = bookData
    const { minReservationDuration } = reservationProperty
    let beforeFlag = true
    let afterFlag = true
    for (let i = 0; i < beforeList.length; i++) {
      const item = beforeList[i]
      const { duration, ratio } = item
      if (duration && !ratio) {
        beforeFlag = false
      } else if (!duration && ratio) {
        beforeFlag = false
      }
    }
    for (let i = 0; i < afterList.length; i++) {
      const item = afterList[i]
      const { duration, ratio } = item
      if (duration && !ratio) {
        afterFlag = false
      } else if (!duration && ratio) {
        afterFlag = false
      }
    }
    if (rangDates.length == 0) {
      message.error('请选择可预订时间')
      return false
    }
    if (!minReservationDuration) {
      message.error('请选择最低预订时间')
      return false
    }
    if (!beforeFlag) {
      message.error('预订时间前数据请填写完整')
      return false
    }
    if (!afterFlag) {
      message.error('预订时间后数据请填写完整')
      return false
    }
    return true
  }
  message.error('请填写完数据再提交！')
  return false
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/postData.js